import actionCreatorFactory from 'typescript-fsa';
import { Country } from '../../utils/country';
const actionCreator = actionCreatorFactory('StreamEdit');

export const createCountry = actionCreator<{ country: Country }>(
  'COUNTRY_CREATE'
);



// WEBPACK FOOTER //
// ./src/store/Country/country.actions.ts